import {Component, inject} from '@angular/core';
import {AConst} from '../../core/a-const.enum';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ConfirmDialogData {
  modalTitle: string;
  modalContent: string | string[];
  modalButton?: string;
  modalCancel?: string;
  modalConfirm?: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent {
  // Injections
  public data: ConfirmDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<ConfirmDialogComponent> = inject(MatDialogRef);

  AConst = AConst;
}
